/**
 * The function is a wrapped around the native `navigator.mediaDevices.getUserMedia()`.
 * It must be called anywhere in the code instead of `navigator.mediaDevices.getUserMedia()`
 * to workaround the "Safari does not play video in low power mode" issue (LIQA-1199).
 *
 * Do not mix the `getUserMedia()` with `navigator.mediaDevices.getUserMedia()` calls
 * since it leads to duplicate permission prompts on Safari (LIQA-1439).
 */
export const getUserMedia = (...args: Parameters<MediaDevices["getUserMedia"]>) =>
  // TODO: can the `parent` be removed somehow?
  /*
   * The `parent` is used here as a workaround for the Safari low power mode issue:
   * Safari does not play video if it‘s created in another execution context than it‘s rendered to.
   *
   * The video is rendered in the parent‘s page execution context.
   * The `parent` usage below forces the video to be created in the same, parent‘s, execution context, and not in the ShadowRealm‘s one.
   */
  parent.navigator.mediaDevices.getUserMedia(...args)

export const enumerateDevices = (...args: Parameters<MediaDevices["enumerateDevices"]>) =>
  parent.navigator.mediaDevices.enumerateDevices(...args)

export const getSupportedConstraints = () => parent.navigator.mediaDevices.getSupportedConstraints()
